
import { getPhoneTopStyle } from '@/composables/fxwallet'
import { defineComponent } from 'vue'

export default defineComponent({
  setup () {
    const { phoneStyle } = getPhoneTopStyle()

    return {
      phoneStyle
    }
  }
})
